// eslint-disable-next-line import/no-extraneous-dependencies
import { createMemoryHistory } from 'history';

const history = createMemoryHistory();

export default history;
